import React, { useEffect, useCallback } from 'react';
import { observer } from 'mobx-react';
import { BaseModal } from '../../../../common/components/BaseModal/BaseModal';
import { EntitiesListPanel } from './EntitiesListPanel';
import { EntityDetailPanel } from './EntityDetailPanel';
import { MobileModalContent } from './EntitiesPanelModal.styles';

export const EntitiesPanelModal = observer((props) => {
    const {
        showEntityDetail,
        selectedEntity,
        handleBackToList,
        handleEditEntity,
        handleDeleteEntity,
        entities,
        selectedEntityId,
        handleEntitySelect,
        handleAddEntity,
        isOpen = false,
        onClose
    } = props;

    const handleClose = useCallback(() => {
        onClose?.();
        handleBackToList();
    }, [onClose, handleBackToList]);

    useEffect(() => {
        if (!isOpen) {
            return;
        }

        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                handleClose();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, handleClose]);

    if (!isOpen) {
        return null;
    }

    const mainContent = showEntityDetail && selectedEntity ? (
        <EntityDetailPanel
            entity={selectedEntity}
            onBack={handleBackToList}
            onEdit={handleEditEntity}
            onDelete={handleDeleteEntity}
        />
    ) : (
        <EntitiesListPanel
            entities={entities}
            selectedEntityId={selectedEntityId}
            onEntitySelect={handleEntitySelect}
            onAddEntity={handleAddEntity}
            onEditEntity={handleEditEntity}
            onDeleteEntity={handleDeleteEntity}
        />
    );

    return (
        <BaseModal
            width="512px"
            height="512px"
            borderRadius={20}
            onBackDropClick={handleClose}
        >
            <MobileModalContent>
                {mainContent}
            </MobileModalContent>
        </BaseModal>
    );
}); 